import React, { useState } from "react";
import { connect } from "react-redux";
import { removeItem, updateQuantityItem } from "../../redux/cart/action";
import { styles } from "./cart.styles";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  // faPlus,
  // faMinus,
  faMinusCircle,
  faPlusCircle
} from "@fortawesome/free-solid-svg-icons";
import { serverResponse } from "../../util/fakeServer";
const CartItem = (props) => {
  const {
    item: {
      image_file,
      field1,
      description,
      skul,
      currentPrice,
      quantity,
      grocery_label,
      old_price = -1
    },
    showOldPrice = false,
    removeItem,
    showQuantity = true
  } = props;

  const [loadingItem, setLoadingItem] = useState(false);

  const priceFormatter = !showOldPrice ? (
    <p>{parseFloat(currentPrice).toFixed(2)} €</p>
  ) : (
    <p>
      Prezzo Precedente <del>{old_price.toFixed(2)}</del> | Nuovo Prezzo{" "}
      {parseFloat(currentPrice).toFixed(2)}
    </p>
  );

  return (
    <div style={styles.itemContainer}>
      <img
        className="img-fluid"
        style={styles.image}
        src={image_file}
        alt={field1}
      />
      <div style={styles.infoContainer}>
        <p className="mt-3" style={styles.description}>
          {description}
        </p>
        {priceFormatter}
      </div>

      {loadingItem ? (
        <div className=" d-flex" style={styles.loadingContainer}>
          <div className="spinner-grow" style={styles.spinner} role="status" />
        </div>
      ) : (
        <>
          {showQuantity && (
            <div style={styles.quantityContainer} className="d-flex">
              <FontAwesomeIcon
                className="pointer"
                icon={faMinusCircle}
                onClick={() => {
                  if (quantity > 1) {
                    setLoadingItem(true);
                    props.updateQuantityItem(skul, -1, setLoadingItem);
                  }
                }}
                size="sm"
                color={serverResponse.config.primary_color}
              />

              <p style={styles.quantity}>
                {quantity} {grocery_label}
              </p>
              <FontAwesomeIcon
                className="pointer"
                icon={faPlusCircle}
                onClick={() => {
                  setLoadingItem(true);
                  props.updateQuantityItem(skul, 1, setLoadingItem);
                }}
                size="sm"
                color={serverResponse.config.primary_color}
              />
            </div>
          )}

          <div
            onClick={() => removeItem(skul)}
            style={styles.cartRemoveContainer}
            className="pointer"
          >
            <img
              className="img-fluid"
              src="https://view.interattivo.net/static/media/Cart_remove.4af7dc28.svg"
              alt="cart-remove"
            />
          </div>
        </>
      )}
    </div>
    // <p key={props.item.skul}>
    //   {props.item.field1 + " qta: " + props.item.quantity}{" "}
    //   <button onClick={() => props.removeItem(props.item.skul)}>Remove</button>
    // </p>
  );
};

export default connect(null, { removeItem, updateQuantityItem })(CartItem);
